module.exports = __webpack_public_path__ + "img/tevredenheidsgarantie@small.5693d2d5.jpg";